import { DataGrid } from "@mui/x-data-grid";
import {
  CmpTypographyField,
  CmpDatePickerField,
  CmpSelectField,
  CmpSelectArrField,
  CmpInputField,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import Grid from "@mui/material/Grid";
import {
  CmpDatePickerField001V1,
  CmpSelectArrFieldV1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCHead({
  sAdjustmentType,
  fAdjustmentType,
  vMediaQuery,
  //grid saleshistory end
  vRdxWmsHead,
  sDocLoadingGrnType,
  fonSelectedGrnType,
  fInvDate,

  fFromLocation,

  xKey,
  xFocusInput,
  sFromLocation,
  xErrorMsg,
  xDisableBasedOnGridDataLength,
  inputFocus,
  sBufferItmCd,
  headGridShow,
  sHeadGridColumn,
  sHeadGridRow,
  fonChangeDo,

  //GC customer
  xonChangeInputCustomer,
  xhandleClick,
  xrowDropdownSearch,
  xcolumnsDropdownSearch,
  xOnCellKeyDown,
  xOnRowClick,
  xToggleDropdown,
  xData,
  xOnChange,
  xDropdownObj,
  xOnKeyUp,
}) {
  return (
    <form id="WmsStockAdjustmentHead">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 0 }}
        columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={5}
          lg={5}
          className={vMediaQuery ? "" : "pe-5"}
        >
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            <Grid item xs={6} sm={4} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={fonSelectedGrnType}
                xName={"A_VocTyp"}
                xData={sDocLoadingGrnType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={
                  xDisableBasedOnGridDataLength || vRdxWmsHead.A_VocNo != 0
                }
                // xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={6}>
              <CmpTextFieldV1
                xLabelText="Doc.No"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocNo}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={6}>
              <CmpDatePickerField001V1
                xLabelText="Doc.Date"
                xtabIndex={"2"}
                xValue={vRdxWmsHead.A_RefDt}
                xOnChange={fInvDate}
                xName={"A_RefDt"}
                xError={xErrorMsg.A_RefDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_RefDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>
 

            <Grid item xs={6} sm={4} md={6}>
              <CmpSelectFieldV1
                xtabIndex={"115"}
                xLabelText="Adjustment Type"
                xValue={vRdxWmsHead.AdjustmentType}
                xOnChange={(e) => {
                  fAdjustmentType(e);
                }}
                xName={"AdjustmentType"}
                xData={sAdjustmentType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.AdjustmentType === "" ? false : true}
                xErrorMessage={xErrorMsg.AdjustmentType}
                xDisable={false}
                // xOnKeyUp={""}
  
               
              />
            </Grid>
          </Grid>
        </Grid>
        {!headGridShow && (
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <Grid
              container
              spacing={0}
              columnSpacing={{ xs: 0, sm: 0.9, md: 1 }}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className={
                hasValueInErrorMessage(xErrorMsg)
                  ? "align-items-center"
                  : "align-items-start"
              }
            >
              <Grid item xs={6} sm={4} md={6}>
                <CmpSelectFieldV1
                  xtabIndex={"5"}
                  xLabelText="Location"
                  xValue={vRdxWmsHead.A_FromLoc}
                  xOnChange={fFromLocation}
                  xName={"A_FromLoc"}
                  xData={sFromLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_FromLoc === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_FromLoc}
                  xDisable={xDisableBasedOnGridDataLength || sBufferItmCd}
                />
              </Grid>

              <Grid item xs={6} sm={4} md={6}>
                <CmpTextFieldV1
                  xLabelText="Batch"
                  xValue={vRdxWmsHead.A_FromLocBatch}
                  xType={"text"} // text/number/password
                  xName={"A_FromLocBatch"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={xErrorMsg.A_FromLocBatch === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_FromLocBatch}
                  xOnKeyUp={xKey}
                />
              </Grid>
              <Grid item xs={2} sm={1} md={1}>
                <CmpCheckboxField
                  xChecked={vRdxWmsHead.A_Do == "Y"}
                  xOnChange={fonChangeDo}
                  // xDisabled={vRdxWmsHead?.Batch?.toUpperCase() == "BATCH : NO"}
                  xDisabled={xDisableBasedOnGridDataLength}
                  xName={"DO"}
                  xNameField={"DO"}
                  xError={xErrorMsg.A_Do === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_Do}
                  // sales_onvoice_check_box="start"
                />
              </Grid>

              {false && (
                <Grid item xs={9} sm={10} md={10} lg={10}>
                  <Grid container spacing={0.9}>
                    <Grid item xs={3} sm={2} md={2} lg={2}>
                      <CmpTextFieldV1
                        xLabelText="Customer"
                        xValue={vRdxWmsHead.A_Party}
                        xType={"text"} // text/number/password
                        xName={"A_Party"}
                        xReadOnly={true}
                        xOnChange={""}
                        xError={xErrorMsg.A_Party === "" ? false : true}
                        xErrorMessage={xErrorMsg.A_Party}
                      />
                    </Grid>
                    <Grid item xs={9} sm={10} md={10} lg={10}>
                      <GCToggleSearchV1
                        xLabelText="Customer"
                        xName={"A_PartyName"}
                        xType={"text"}
                        xValue={vRdxWmsHead.A_PartyName}
                        xReadOnly={false}
                        xOnChange={(e) => {
                          xonChangeInputCustomer(e);
                        }} //GCToggleSearch onchange main input
                        xOnKeyUp={(e) => {
                          xhandleClick(e, "customer");
                        }} //GCToggleSearch xOnKeyUp main input
                        xError={xErrorMsg.A_PartyName === "" ? false : true}
                        xErrorMessage={xErrorMsg.A_PartyName}
                        xMediaQuery={false}
                        xonClickbtn={xhandleClick} // GCToggleSearch onclick icon open div on main screen
                        xrows={xrowDropdownSearch} //GCToggleSearch-grid
                        xcolumns={xcolumnsDropdownSearch} //GCToggleSearch-grid
                        xRowCellClick={xOnCellKeyDown}
                        xRowClick={xOnRowClick}
                        xToggle={xToggleDropdown} //GCToggleSearch- true/false
                        xData={xData} //GCToggleSearch-select
                        xOnChangeDropdownInput={xOnChange} //GCToggleSearch -input
                        xDropdownObj={xDropdownObj} //GCToggleSearch -obj
                        xOnKeyUpDropdownInput={xOnKeyUp} //GCToggleSearch -Enter key and clickc detect
                        xtabIndex="5"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        {headGridShow && (
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <div style={{ height: "150px", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sHeadGridRow}
                columns={sHeadGridColumn}
                onRowClick={() => {}}
                hideFooter={sHeadGridRow.length < 100}
                // components={{
                //   Toolbar: GridToolbar,
                // }}
              />
            </div>
          </Grid>
        )}
      </Grid>
    </form>
  );
}
